import { BasePostProvider, DataTransformationProtocol } from "@tendercuts/http";
import { EndPoint } from "@endpoint";
import { SaleOrder } from "@tendercuts/models";
import { Injectable } from "@angular/core";
import { LoginServices } from "@login";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class InstantSyncOrderService extends BasePostProvider<SaleOrder>
  implements DataTransformationProtocol {
  constructor(
    public http: HttpClient,
    public endpointService: EndPoint,
    public loginService: LoginServices
  ) {
    super(http);
    this.delegate = this;
  }


  preProcessResponse(response) {
    return response.results;
  }

  get isAuthenticatedEndpoint() {
    return true;
  }

  get authProtocol() {
    return this.loginService;
  }

  get model() {
    return SaleOrder;
  }

  get endpoint() {
    return this.endpointService.placeComboOrder();
  }
}
